import type { MailListLog } from "../store/schema/MailListLogsStore";
import { mailListLogsStore } from "../store/store";

export function getMailListLogs(): MailListLog[] {
    return mailListLogsStore.mailListLogs;
}
